import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=1236cbce&"
import script from "./Receipts.vue?vue&type=script&lang=js&"
export * from "./Receipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports